/* eslint-disable jsx-a11y/media-has-caption */
import { Card } from 'antd'
import MAudio from 'components/elements/Mcomponents/MAudio'
import moment from 'moment'
import { FC, useState } from 'react'
import { toTitleCase } from 'utils/functions'
import CallDirectionAvatar from './CallDirectionAvatar'
import useCallRecording from '../hooks/useCallRecording'
import { TCall } from '../types'
import {
 formatCallDuration,
 formatPhoneNumber,
 getCallTypeLabel,
} from '../utils'

const { Meta } = Card

const CallRow: FC<{ call: TCall; leadId?: any }> = ({ call, leadId }) => {
 const [expanded, setExpanded] = useState(false)
 const recording = useCallRecording()

 const handleToggle = () => {
  const next = !expanded
  setExpanded(next)
  if (next && call.has_recording && !recording.src) {
   recording.load(
    leadId
     ? `user/leads/${leadId}/calls/${call.id}/recording`
     : `user/calls/${call.id}/recording`,
   )
  }
 }

 const number = call.direction === 'inbound' ? call.from_number : call.to_number
 const formattedNumber = formatPhoneNumber(number)

 return (
  <Card hoverable style={{ borderColor: '#ccc' }} className="mb-2">
   <div
    className="d-flex justify-content-between align-items-center"
    style={{ cursor: 'pointer' }}
    onClick={handleToggle}
   >
    <Meta
     avatar={
      <CallDirectionAvatar direction={call.direction} status={call.status} />
     }
     description={
      <div>
       <h3 className="mb-0 mt-0">
        {toTitleCase(call.contact_name) || formattedNumber}
        {call.has_recording && (
         <i className="fas fa-play-circle call-item-rec-badge ms-2" />
        )}
       </h3>
       {call.contact_name && (
        <p className="mb-0 mt-1 text-muted" style={{ fontSize: '13px' }}>
         {formattedNumber}
        </p>
       )}
       <p className="mb-0 mt-2" style={{ fontSize: '13px' }}>
        <span style={{ border: '1px solid #ccc', padding: '0 7px' }}>
         {moment(call.created_at).format('MMM DD, YYYY h:mm A')}
        </span>
       </p>
      </div>
     }
    />
    <i
     className={`fas fa-chevron-${expanded ? 'up' : 'down'} call-item-caret`}
    />
   </div>
   {expanded && (
    <div className="call-item-detail mt-3" onClick={(e) => e.stopPropagation()}>
     <div className="call-item-detail-row">
      <span>Phone Number</span>
      <strong>{formattedNumber}</strong>
     </div>
     <div className="call-item-detail-row">
      <span>Call Type</span>
      <strong>{getCallTypeLabel(call.direction, call.status)}</strong>
     </div>
     <div className="call-item-detail-row">
      <span>Duration</span>
      <strong>{formatCallDuration(call.duration)}</strong>
     </div>
     {call.has_recording ? (
      recording.error ? (
       <div className="text-danger">{recording.error}</div>
      ) : (
       <MAudio
        src={recording.src ?? ''}
        loading={recording.loading || !recording.src}
       />
      )
     ) : (
      <div className="text-muted">No recording available</div>
     )}
    </div>
   )}
  </Card>
 )
}

export default CallRow
